// src/components/loyalty/loyalty-member-status.tsx
function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  query loyalty($context: ContextInput!) {\n    loyalty(context: $context) {\n      member {\n        firstName\n      }\n      memberStatus\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import React from "react";
import { gql, useQuery } from "@apollo/client";
import { EGDSSpacing } from "@egds/react-core/spacing";
import { EGDSHeading, EGDSSubheading } from "@egds/react-core/text";
import { useBexApi } from "@shared-ui/bex-api-context";
var __LoyaltyQuery = gql(_templateObject());
var LoyaltyMemberStatus = function(props) {
    var _loyalty_member;
    var skipSsr = props.skipSsr;
    var context = useBexApi().context;
    var _useQuery = useQuery(__LoyaltyQuery, {
        variables: {
            context: context
        },
        ssr: !skipSsr
    }), data = _useQuery.data, error = _useQuery.error, loading = _useQuery.loading;
    if (loading || error || !data) {
        return null;
    }
    var loyalty = data.loyalty;
    if (!loyalty || !((_loyalty_member = loyalty.member) === null || _loyalty_member === void 0 ? void 0 : _loyalty_member.firstName) || !loyalty.memberStatus) {
        return null;
    }
    return /* @__PURE__ */ React.createElement(EGDSSpacing, {
        padding: "six"
    }, /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(EGDSHeading, {
        tag: "h2",
        size: 5
    }, loyalty.member.firstName), /* @__PURE__ */ React.createElement(EGDSSubheading, {
        tag: "h3"
    }, loyalty.memberStatus)));
};
LoyaltyMemberStatus.displayName = "sharedui-LoyaltyMemberStatus";
export { LoyaltyMemberStatus };
//# sourceMappingURL=index.js.map